import { useState } from "react";
import Button from "../../../components/Button/Button";
import FormSelect from "../../../components/Form/FormSelect";
import CheckboxField from "../../../components/Form/CheckboxField";
import { Dialog, applicantName } from "./applicationParts";

const legalEntities = ["Private Limited", "LLP", "Sole Proprietorship", "Partnership"];

// Asks for what the application form does not collect but a vendor needs.
const AcceptApplicationModal = ({ application, onConfirm, onClose }) => {
  const [legalEntity, setLegalEntity] = useState("");
  const [canLogin, setCanLogin] = useState(true);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const handleConfirm = async () => {
    if (!legalEntity) {
      setError("Legal Entity is required.");
      return;
    }
    setSaving(true);
    const ok = await onConfirm({ legal_entity: legalEntity, can_login: canLogin });
    if (!ok) setSaving(false);
  };

  return (
    <Dialog
      title="Accept Application"
      onClose={() => !saving && onClose()}
      footer={
        <>
          <Button variant="secondary" size="sm" onClick={onClose} disabled={saving}>
            Cancel
          </Button>
          <Button size="sm" onClick={handleConfirm} disabled={saving}>
            {saving ? "Accepting..." : "Accept"}
          </Button>
        </>
      }
    >
      <div className="space-y-4">
        <p className="text-[13px] leading-relaxed text-gray-600">
          <span className="font-medium text-gray-900">
            {application.company_name || applicantName(application)}
          </span>{" "}
          will be added to your vendors with the details, language pairs, specializations and files
          from the application.
        </p>
        <FormSelect
          label="Legal Entity"
          name="legal_entity"
          value={legalEntity}
          onChange={(e) => {
            setLegalEntity(e.target.value);
            setError("");
          }}
          options={legalEntities}
          error={error}
          required
        />
        <CheckboxField
          label="Can Login"
          name="can_login"
          checked={canLogin}
          onChange={(e) => setCanLogin(e.target.checked)}
          hint="If checked, the vendor is emailed an invitation to activate their vendor portal account."
        />
      </div>
    </Dialog>
  );
};

export default AcceptApplicationModal;
